module.exports = __webpack_public_path__ + "img/tip_2.af903a5a.png";